import script from "./MeetingList.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingList.vue?vue&type=script&setup=true&lang=js"

import "./MeetingList.vue?vue&type=style&index=0&id=2d564f8a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d564f8a"]])

export default __exports__